import React from 'react';

import ChangePasswordContainer from '@src/components/password/change/ChangePasswordContainer';

const ChangePasswordPage = () => <ChangePasswordContainer />;

export default ChangePasswordPage;
